import Vue from 'vue';
import VueRouter from 'vue-router';
import { isEnvMobile } from '@/common/utils';
import { getRouterBase } from '@/common/utils/routePrefix';
import { ROUTER_TITLE } from '@/common/constants';
import pcRoutes from './routes/pc';
import mobileRoutes from './routes/mobile';

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  base: getRouterBase(),
  routes: [
    {
      path: '/',
      redirect: '/home',
    },
    {
      path: '/pc',
      name: 'pc',
      component: () => import('@/views/common/container/Pc.vue'),
      children: pcRoutes,
    },
    {
      path: '/m',
      name: 'm',
      component: () => import('@/views/common/container/Mobile.vue'),
      children: mobileRoutes,
    },
    {
      path: '/liuzi',
      name: 'liuzi',
      component: () => import('@/views/liuzi'),
    },
    {
      path: '*',
      name: 'notFound',
      component: () => import('@/views/common/notice/NotFound.vue'),
    },
  ],
});

/**
 * @description: pc和mobile切换方法
 */
const isMobile = isEnvMobile();
const getRoutes = router.getRoutes();

// 切换匹配路由
const tryPath = (findPath, to, next) => {
  try {
    let isMatch = false;
    // 去除末尾/，目的：保障切换路由正常
    let _findPath = findPath.replace(/\/+$/, "");
    for (const _route of getRoutes) {
      if (_route.path === _findPath) {
        isMatch = true;
        break;
      }
    }
    if (isMatch) {
      next({
        path: _findPath,
        query: to.query,
      });
    } else {
      throw isMatch;
    }
  } catch (_) {
    next();
  }
};

// 路由前置守卫
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  document.title = to.meta.title || ROUTER_TITLE;

  // 非 /edu 模式下，纠正硬编码带 /edu 前缀的路径
  if (router.options.base !== '/edu' && to.path.startsWith('/edu')) {
    next({
      path: to.path.replace(/^\/edu/, '') || '/',
      query: to.query,
      hash: to.hash,
      replace: true,
    });
    return;
  }

  if (from.query.chn !== undefined && to.query.chn === undefined) {
    to.query.chn = from.query.chn;
    next(to);
    return;
  }

  const decodeFullPath = decodeURIComponent(to.fullPath);
  const spaceIndex = decodeFullPath.indexOf(' ');
  if (spaceIndex !== -1) {
    const nextFullPath = decodeFullPath.slice(0, spaceIndex);
    next({
      path: nextFullPath,
      replace: true,
    });
    return;
  }

  const isPCPage = to.path.indexOf('/m/') === -1;
  // m端访问pc页面
  if (isPCPage && isMobile) {
    tryPath('/m' + to.path, to, next);
    return;
  }

  // pc端访问m页面
  if (!isPCPage && !isMobile && to.path.indexOf('/m/') === 0) {
    tryPath(to.path.slice(2), to, next);
    return;
  }

  /* 必须调用 `next` */
  next();
});

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch((err) => err);
};

export default router;
